module.exports = __webpack_public_path__ + "img/live-cards-banner2.dc9c351.gif";